import React, { useState, useLayoutEffect } from "react";
import { useStore } from 'react-context-hook';
import styled from "styled-components";
import "antd/dist/antd.css";
import {Button, Radio, Slider, Switch, Divider, Card, Select} from 'antd';
import Description from "./description";
import "antd/dist/antd.css";

const { Option } = Select;

const SetupWrapper = styled.div`
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const InnerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
`;

const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 8px 0;
`;

const RowLabel = styled.div`
    margin-right: 8px;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 16px;
`;

const StyledButton = styled(Button)`
    margin: 2px;
`;

const StyledSlider = styled(Slider)`
    width: 100px;
`;

let apiHost = 'http://127.0.0.1:8000';
if (process.env.NODE_ENV === 'production') {
    apiHost = 'https://tichu-backend.herokuapp.com';
}

const SetupScreen = ({socket, join}) => {

    const [models, setModels] = useState({
        available_models: [],
        loaded_model: 0,
    });

    useLayoutEffect(() => {
        fetch(apiHost + '/models')
            .then(res => res.json())
            .then((data) => {
                setModels(data);
            })
            .catch(console.log);
    }, []);

    const [players, setPlayers] = useStore('agents', [0, 2, 2, 2]);
    const [aiDelay, setAiDelay] = useStore('ai_delay', 3);

    const [mctsCutoff, setMctsCutoff] = useStore('mcts_cutoff', 500);
    const [mctsSearchTime, setMctsSearchTime] = useStore('mcts_search_time', 10);

    const [mctsEnabled, setMctsEnabled] = useStore('mcts_enabled', false);


    const [, setStorePlayer] = useStore('player', -1);
    const [player, setPlayer] = useState(0);

    const onAgentSwitch = (e, position) => {
        const curPlayers = players;
        curPlayers[position] = e.target.value;
        setPlayers(curPlayers);
    }

    const onPlayerSwitch = (e) => {
        setPlayer(e.target.value);
    }

    const onDelaySwitch = (e) => {
        setAiDelay(e);
    }

    const onModelChange = (e) => {
        setAiDelay(e);
    }


    const onStart = () => {
        setStorePlayer(player);
        if (window.gtag) {
            window.gtag('event', 'start', {
                'event_category' : 'button',
                'event_label' : 'Start Game Button Pressed',
                'value': players[0] + players [1] + players [2]  + players [3]
            });
        }
        if (!join) socket.emit('start', {players: players, ai_delay: aiDelay, mcts_enabled: mctsEnabled, mcts_cutoff: mctsCutoff, mcts_search_time: mctsSearchTime, model_index: models.loaded_model});
    };
    return (
        <SetupWrapper>
            <InnerWrapper>
            <Card title="Game Setup">
            {!join && (
                <>
                    <RowWrapper>
                        <RowLabel>Player 0:</RowLabel>
                        <Radio.Group onChange={(e) => onAgentSwitch(e, 0)} defaultValue={players[0]}
                                     buttonStyle="solid">
                            <Radio.Button value={0}>Human</Radio.Button>
                            {/*<Radio.Button value={1}>Random</Radio.Button>*/}
                            <Radio.Button value={2}>AI</Radio.Button>
                        </Radio.Group>
                    </RowWrapper>
                    <RowWrapper>
                        <RowLabel>Player 1:</RowLabel>
                        <Radio.Group onChange={(e) => onAgentSwitch(e, 1)} defaultValue={players[1]}
                                     buttonStyle="solid">
                            <Radio.Button value={0}>Human</Radio.Button>
                            {/*<Radio.Button value={1}>Random</Radio.Button>*/}
                            <Radio.Button value={2}>AI</Radio.Button>
                        </Radio.Group>
                    </RowWrapper>
                    <RowWrapper>
                        <RowLabel>Player 2:</RowLabel>
                        <Radio.Group onChange={(e) => onAgentSwitch(e, 2)} defaultValue={players[2]}
                                     buttonStyle="solid">
                            <Radio.Button value={0}>Human</Radio.Button>
                            {/*<Radio.Button value={1}>Random</Radio.Button>*/}
                            <Radio.Button value={2}>AI</Radio.Button>
                        </Radio.Group>
                    </RowWrapper>
                    <RowWrapper>
                        <RowLabel>Player 3:</RowLabel>
                        <Radio.Group onChange={(e) => onAgentSwitch(e, 3)} defaultValue={players[3]}
                                     buttonStyle="solid">
                            <Radio.Button value={0}>Human</Radio.Button>
                            {/*<Radio.Button value={1}>Random</Radio.Button>*/}
                            <Radio.Button value={2}>AI</Radio.Button>
                        </Radio.Group>
                    </RowWrapper>
                    <Divider />
{/*                    <RowWrapper>
                        <RowLabel>AI Agent:</RowLabel>
                        <Select value={models.loaded_model} onChange={(value) => setModels({...models, loaded_model: value})}>
                            {models.available_models.map((model, index) => (
                                <Option value={index}>{model.label}</Option>
                            ))}
                        </Select>
                    </RowWrapper>
                    <Divider />*/}
                    <RowWrapper>
                        <RowLabel>AI Move Delay (s):</RowLabel>
                        <StyledSlider onAfterChange={onDelaySwitch} defaultValue={aiDelay} min={1} max={10}/>
                    </RowWrapper>
                    <Divider />
{/*                    <RowWrapper>
                        <RowLabel>End Game MCTS:</RowLabel>
                        <Switch checked={mctsEnabled} onChange={((checked, e) => setMctsEnabled(checked))} />
                    </RowWrapper>
                    {mctsEnabled && (
                        <>
                            <RowWrapper>
                                <RowLabel>Possible Moves Cutoff:</RowLabel>
                                <StyledSlider onAfterChange={(e) => setMctsCutoff(e)} defaultValue={mctsCutoff} min={10} max={1000}/>
                            </RowWrapper>
                            <RowWrapper>
                                <RowLabel>Search Time per Move (s):</RowLabel>
                                <StyledSlider onAfterChange={(e) => setMctsSearchTime(e)} defaultValue={mctsSearchTime} min={1} max={20}/>
                            </RowWrapper>
                        </>
                    )}
                    <Divider />*/}
                </>
            )}
            <RowWrapper>
                <RowLabel>Your Seat:</RowLabel>
                <Radio.Group onChange={onPlayerSwitch} defaultValue={0} buttonStyle="solid">
                    <Radio.Button value={0}>0</Radio.Button>
                    <Radio.Button value={1}>1</Radio.Button>
                    <Radio.Button value={2}>2</Radio.Button>
                    <Radio.Button value={3}>3</Radio.Button>
                </Radio.Group>
            </RowWrapper>
            <Divider />
            <ButtonWrapper>
                <StyledButton type="primary" onClick={onStart}>{join ? "Join Game" :"Start Game"}</StyledButton>
            </ButtonWrapper>
            </Card>
            <Description />
            </InnerWrapper>
        </SetupWrapper>
    );
};

export default SetupScreen;
